webpackJsonp([0],{

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contact',
  data: function data() {
    return {
      email: '',
      msg: '',
      status: '',
      statusText: '',
      buttonText: 'Send'
    };
  },

  created: function created() {
    window.scrollTo(0, 0);
  },
  methods: {
    writing: function writing() {
      this.status = '';
      this.statusText = '';
      this.buttonText = 'Send';
    },
    sendButton: function sendButton() {
      // catch warnings (only email or only msg)
      if (this.status == 'warning') {
        this.change('sending', "Sending your message", "Sending...");
        this.toServer();
      } else {
        // catch no email & no msg
        if (!this.email.length && !this.msg.length) {
          this.change('fail', "There is no e-mail or messege to send", "Can't send");
        }
        // catch only msg
        else if (!this.email.length && this.msg.length) {
            this.change('warning', "You don't want to provide your e-mail?", "Yes, send anonymous message");
            this.focusTo('sendButton');
          }
          // catch if email is correct
          else if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)) {
              // catch if email is correct and msg is not empty
              if (this.msg.length) {
                this.change('sending', "Sending your message", "Sending...");
                this.toServer();
                // catch if email is correct and no msg
              } else {
                this.change('warning', "You don't want to write any messege?", "Yes, send only e-mail");
                this.focusTo('sendButton');
              }
              // catch if email is invalid
            } else {
              var self = this;
              this.change('fail', 'Something wrong with your e-mail, fix it please', "Can't send");
              setTimeout(function () {
                self.focusTo('email');
              }, 200);
            }
      }
    },
    toServer: function toServer() {
      var self = this;

      // setTimeout(function () {
      //   console.info( 'server 200' )
      //   self.email = ''
      //   self.msg = ''
      //   self.change('success', "Your messege was seccessefully sent", "Send")
      //   self.$forceUpdate()
      // }, 1000)

      setTimeout(function () {
        console.info('server 500');
        self.change('warning', 'Thanks for your effort, but this contact form is not working. Will be fixed soon', "Send again");
        self.$forceUpdate();
        setTimeout(function () {
          self.focusTo('sendButton');
        }, 0);
      }, 1200);
    },
    change: function change(status, statusText, buttonText) {
      this.status = status;
      this.statusText = statusText;
      this.buttonText = buttonText;
    },
    focusTo: function focusTo(id) {
      document.getElementById(id).focus();
    }
  }
});

/***/ }),

/***/ "08Uv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Skills")]),_c('div',{staticClass:"container"},_vm._l((_vm.skills),function(skill){return _c('div',{staticClass:"item",class:[ skill.width ]},[_c('h3',[_vm._v(_vm._s(skill.name))]),_c('b',_vm._l((skill.stars),function(star){return _c('span',{domProps:{"innerHTML":_vm._s(_vm.SVGstar)},on:{"click":_vm.dropStar,"contextmenu":function($event){$event.preventDefault();return _vm.dropStar($event)}}})}),0),_c('small',[_vm._v(_vm._s(skill.desc))])])}),0),(_vm.dropedStars > 5)?_c('i',[_vm._v("You just knocked down "+_vm._s(_vm.dropedStars)+" stars of my experience. Well done!")]):_vm._e(),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "09L2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2DCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'skills',
  data: function data() {
    return {
      skills: [{ name: "Visualization", stars: 5, desc: "I try to visualize everything, for both understanding and explaining the cause", width: 'w100' }, { name: "HTML / CSS", stars: 4, desc: "always adaptive and mobile first", width: 'w50' }, { name: "Animation", stars: 4, desc: "from motion design to web animations", width: 'w50' }, { name: "JavaScript", stars: 3, desc: "Vanilla, Vue, SVG, GSAP, D3, Electron, Babylon", width: 'w33' }, { name: "Startup", stars: 3, desc: "MVP, CAC, LTV, Business model canvas", width: 'w33' }, { name: "Futurology", stars: 3, desc: "only future proof technologies and ideas are worthy", width: 'w33' }, { name: "UI + UX", stars: 3, desc: "understanding of irrational human behaviour is essential", width: 'w25' }, { name: "Backend dev", stars: 2, desc: "can deal with Node, understand Feathers, REST, websockets", width: 'w25' }, { name: "Marketing", stars: 2, desc: "know something about attention, retention, funnels", width: 'w25' }, { name: "Financial", stars: 2, desc: "some experience in predictive analytics, financial statements", width: 'w25' }, { name: "Photo", stars: 3, desc: "prefer manual mode on camera, can do photo editing and photo manipulations", width: 'w33' }, { name: "Video", stars: 3, desc: "worked with camera, editing, motion design, VFX", width: 'w33' }, { name: "Sound / Music", stars: 3, desc: "know how to get from idea to master track, in film and music", width: 'w33' }, { name: "Computer science", stars: 1, desc: "trying to wrap my head around machine learning and neural networks", width: 'w25' }, { name: "Sales", stars: 1, desc: "can setup CRM or write a script, know that ignoring is not a «No»", width: 'w25' }, { name: "Working", stars: 3, desc: "sprinter, good at short, highly tense distances with too much variables", width: 'w25' }, { name: "Communication", stars: 2, desc: "they call me Sheldon, I don't get it", width: 'w25' }],
      SVGstar: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 510"><path shape-rendering="geometricPrecision" d="M255 402.2l157.6 95L371 318l139-120.5-183.4-15.8-71.6-169-71.6 169L0 197.5 139 318 97.5 497.3"/></svg>',
      dropedStars: 0
    };
  },

  created: function created() {
    window.scrollTo(0, 0);
  },
  methods: {
    dropStar: function dropStar(e) {
      var star = e.target.tagName == "path" ? e.target.parentNode.parentNode : e.target.tagName == "svg" ? e.target.parentNode : e.target; // because span>svg>path
      star.style.transition = 'opacity 0.5s, transform 1s';
      star.style.opacity = 0;
      star.style.transform = 'scaleY(0.5) translateY(400px)';
      setTimeout(function () {
        star.style.transform = 'scaleY(1) translateY(0)';
      }, 2000);
      setTimeout(function () {
        star.style.opacity = 1;
      }, 8000);
      this.dropedStars++;
    }
  }
});

/***/ }),

/***/ "6X/W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9zQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('nav',[_c('section',{staticClass:"left",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('p',{staticClass:"ava"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 510 510"}},[_c('path',{attrs:{"shape-rendering":"geometricPrecision","d":"M251.4 8C117.3 8 8.6 116.4 8.6 250 8.6 383.7 117.3 492.1 251.4 492.1 385.6 492.1 494.3 383.7 494.3 250 494.3 116.4 385.6 8 251.4 8Zm-59.8 83.2c7.8 0 13.8 2.2 18.1 6.6 4.4 4.3 6.6 9.7 6.6 16.3 0 6.6-2.2 12.1-6.6 16.5-4.3 4.3-10.3 6.4-18.1 6.4-7.7 0-13.7-2.1-17.9-6.4-4.3-4.4-6.4-9.9-6.4-16.5 0-6.6 2.1-12.1 6.4-16.3 4.3-4.4 10.2-6.6 17.9-6.6zm-80.4 72.6 102.4 0 0 156.8 57 0 0 35.1-159.3 0 0-35.1 59.6 0 0-121.5-59.6 0zm131.1 0 43.8 0 47.4 138.4 3 14.2 3.2-14 46.5-138.6 43.8 0-75.2 192-36.5 0z"}})])]),_c('p',{staticClass:"name"},[_vm._v("ilya vasilyev")])]),_c('section',{staticClass:"right"},_vm._l((_vm.menu),function(item,index){return _c('div',{class:{selected: item.path == _vm.$route.fullPath}},[_c('span',[_vm._v("|")]),_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])],1)}),0)]),_c('h1',[_c('span',{attrs:{"id":"typed"},on:{"click":_vm.rndTitle}}),_c('span',{staticClass:"animate-flicker"},[_vm._v("|")])])]),_c('div',{staticClass:"workarea"},[_c('router-view',{attrs:{"name":"a"}}),_c('router-view',{attrs:{"name":"b"}}),_c('router-view',{attrs:{"name":"c"}}),_c('router-view',{attrs:{"name":"y"}}),_c('router-view',{attrs:{"name":"z"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B3Kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'portfolio',
  data: function data() {
    return {
      categories: [{ name: 'all' }, { name: 'code' }, { name: 'design' }, { name: 'video' }, { name: 'audio' }],
      currCategory: 1,
      fullItem: {},
      items: [

      // {
      //   name: "",
      //   category: "",
      //   coverTitle: "",
      //   coverPic: "",
      //   media: [
      //     {
      //       type: "",
      //       comment: "",
      //       file: "",
      //       poster: "",
      //       links: [
      //         {text: "", url: ""},
      //       ]
      //     },
      //   ]
      // },


      {
        category: "code",
        coverTitle: "«MeYou» demo",
        coverPic: "p_meyoudemo_cover.jpg",
        name: "MeYou demo",
        roles: ["Design", "Animation", "Frontend"],
        media: [{
          type: "video",
          commentBefore: "Explanaition demo with different presentation modes and with customisable colors, images and language.",
          commentAfter: "All animation made with SVG and GSAP, assembled with Vue components.",
          file: "p_meyoudemo.mp4",
          poster: "p_meyoudemo_poster.jpg",
          links: [{ text: "Live demo", url: "http://meyoudemo.netlify.com/#/rep" }]
        }]
      }, {
        name: "LBO model",
        category: "code",
        coverTitle: "LBO model",
        coverPic: "p_lbo_cover.jpg",
        roles: ["UI", "UX", "Frontend"],
        media: [{
          comment: "New design and interfaces for full refactoring of dynamic visualisation engine"
        }, {
          type: "video",
          file: "mining.mp4",
          poster: "p_lbo_poster.jpg",
          comment: "Was built in collaboration with Pavel Kityan on Angular 1.6",
          links: [{ text: "Live demo", url: "https://pulsevisuals.ru/lbo" }]
        }]
      }, {
        category: "code",
        coverTitle: "LNG strategic model",
        coverPic: "p_lng_cover.jpg",
        name: "LNG strategic model",
        roles: ["Design", "UI", "UX", "Frontend", "Backend"],
        media: [{
          comment: "Interactive SVG map and dynamic visualisation of strategic infrastructure project"
        }, {
          type: "video",
          file: "lng.mp4",
          poster: "p_lng_poster.jpg",
          comment: "No public link available"
        }]
      }, {
        category: "code",
        coverTitle: "Railroad model",
        coverPic: "p_rail_cover.jpg",
        name: "Railroad model",
        roles: ["Design", "UI", "UX", "Frontend", "Backend"],
        media: [{
          comment: "Multi-scenario visualisation of railroad infrastructure renovation model"
        }, {
          type: "pic",
          file: "p_rail.jpg",
          comment: "No public link available"
        }]
      }, {
        category: "code",
        coverTitle: "Hotel business game",
        coverPic: "p_hotel_cover.jpg",
        name: "Hotel business model",
        roles: ["Design", "UI", "UX", "Frontend", "Backend"],
        media: [{
          comment: "Business game for CFOs of subsidiary companies of AFK Sistema, was built in callaboration with risk management department of PwC Russia"
        }, {
          type: "video",
          file: "p_hotels.mp4",
          poster: "p_hotel_poster.jpg",
          links: [{ text: "Live demo (EN)", url: "https://pulsevisuals.ru/hotel-case/en/" }, { text: "Live demo (RU)", url: "https://pulsevisuals.ru/afk-case/" }]
        }]
      }, {
        category: "code",
        coverTitle: "Meat holding business game",
        coverPic: "p_meat_cover.jpg",
        name: "Meat holding model",
        roles: ["Design", "UI", "UX", "Frontend", "Backend"],
        media: [{
          comment: "Business game for students of Faculty of Economics of Lomonosov Moscow State University"
        }, {
          type: "video",
          comment: ".",
          file: "p_meat.mp4",
          poster: "p_meat_poster.jpg",
          links: [{ text: "Live demo", url: "https://pulsevisuals.ru/meat-holding-case/" }]
        }]
      }, {
        category: "code",
        coverTitle: "«PULSE.visuals»",
        coverPic: "p_pulse_cover.jpg",
        name: "«PULSE.visuals»",
        roles: ["Idea", "Design", "UI", "UX", "Frontend", "Backend"],
        media: [{
          comment: "Landing page",
          links: [{ text: "Open", url: "https://pulsevisuals.ru/" }]
        }, {
          type: "pic",
          file: "p_pulse_intro.gif"
        }, {
          type: "pic",
          file: "p_pulse.jpg"
        }, {
          type: "pic",
          file: "p_pulse2.gif"
        }, {
          type: "pic",
          file: "p_pulse3.jpg"
        }]
      }, {
        category: "code",
        coverTitle: "«PLAIN.solutions»",
        coverPic: "p_charts01.jpg",
        name: "«PLAIN.solutions»",
        roles: ["Idea", "Design", "UI", "UX", "Frontend", "Backend"],
        media: [{
          comment: "Landing page",
          links: [{ text: "Open", url: "http://plain.solutions/" }]
        }, {
          type: "pic",
          file: "p_plain.jpg"
        }, {
          type: "pic",
          file: "p_plain2.jpg"
        }, {
          type: "pic",
          file: "p_charts01.jpg"
        }, {
          type: "pic",
          file: "p_charts02.jpg"
        }, {
          type: "pic",
          file: "p_charts03.jpg"
        }]
      }, {
        category: "code",
        coverTitle: "«Creatomus»",
        coverPic: "p_creatomus00.jpg",
        name: "«Creatomus»",
        roles: ["Design", "Frontend"],
        media: [{
          comment: "I was a part of the winning team in Garage48 GreenTech hackathon in Tallinn",
          links: [{ text: "Event page", url: "http://garage48.org/blog/it-is-raining-winners-at-garage48-greentech-tallinn-2015" }]
        }, {
          type: "pic",
          file: "p_creatomus01.jpg",
          comment: "We've built the prototype of house configurator"
        }, {
          type: "pic",
          file: "p_creatomus02.jpg",
          comment: "It helps home buyers to see how different house parameters affect energy performance and construction costs"
        }, {
          type: "pic",
          file: "p_creatomus00.jpg"
        }, {
          type: "pic",
          file: "p_creatomus03.jpg",
          comment: "That was an amazing international team with estonian architects and marketeers, latvian developers, finnish environmental specialist and russian designer. I was really happy to be part of it."
        }, {
          comment: "This hackaton project managed to grow to a company with powerful product, and today it looks like this:",
          type: "pic",
          file: "p_creatomus04.jpg",
          links: [{ text: "Creatomus Solutions", url: "https://house.creatomus.com/project/hta" }]
        }]
      },

      // DESIGN
      // DESIGN
      // DESIGN

      {
        category: "design",
        coverTitle: "What if analysis",
        coverPic: "p_whatif_cover.jpg",
        name: "What if analysis",
        roles: ["Idea", "UI", "Motion design"],
        media: [{
          type: "video",
          file: "p_whatif.mp4",
          poster: "p_whatif_poster.jpg"
        }]
      }, {
        category: "design",
        coverTitle: "Hockey coach app",
        coverPic: "p_hockey_cover.jpg",
        name: "Hockey coach app",
        roles: ["Design", "UI"],
        media: [{
          comment: "Prototype of the app for hockey coaches and team managers"
        }, {
          type: "pic",
          file: "p_hockey01.jpg"
        },
        // {
        //   type: "pic",
        //   file: "p_hockey02.jpg",
        // },
        {
          type: "pic",
          file: "p_hockey03.jpg"
        }, {
          type: "pic",
          file: "p_hockey04.jpg"
        }, {
          type: "pic",
          file: "p_hockey05.jpg"
        }]
      }, {
        name: "Interactive infographics",
        category: "design",
        coverTitle: "Interactive infographics",
        coverPic: "p_ii.jpg",
        roles: ["Idea", "Motion design", "Music"],
        media: [{
          type: "youtube",
          link: "https://www.youtube.com/embed/-LKNRQJnk8o?rel=0&amp;showinfo=0"
        }]
      }, {
        category: "design",
        coverTitle: "«MeYou» web app",
        coverPic: "p_meyou_ui_cover.jpg",
        name: "«MeYou» web app",
        roles: ["Design", "UI", "UX"],
        media: [{
          comment: "Prototyping of the web app interfaces from scratch for event networking startup, that now is becoming local market leader in event solutions industry",
          links: [{ text: "MeYou", url: "http://meyou.ru/" }]
        }, {
          type: "pic",
          file: "p_meyou_ui.jpg"
        }]
      }, {
        name: "Photo post-production",
        category: "design",
        coverTitle: "Photo post-production",
        coverPic: "p_500px.jpg",
        media: [{
          comment: "Post production of all photos in Yanona's gallery",
          links: [{ text: "Open gallery", url: "https://500px.com/yanona" }]
        }, {
          type: "500px",
          link: "https://drscdn.500px.org/photo/228931907/m%3D900/v2?webp=true&sig=acf6d469948b1911b29267f9cb0ef09f9f132ebe45575185e865d8c61696fbc2"
        }, {
          type: "500px",
          link: "https://drscdn.500px.org/photo/230928069/m%3D900/v2?webp=true&sig=8dc0e15227b39d8fdc645533c9b020067eb0f6a6803ba47b2de077a4b58d22c1"
        }, {
          type: "500px",
          link: "https://drscdn.500px.org/photo/216845447/m%3D900/v2?webp=true&sig=0434e72e5660186d71581c8f4a1f19ba2d9a7b3b8fac2dc69f8e22039ece4e3e"
        }, {
          type: "500px",
          link: "https://drscdn.500px.org/photo/163775361/m%3D900/v2?webp=true&sig=be4591812a1c4688b41a0ec48afb71b321391b096d5d18e7dd77037bbaf9ce9c"
        }, {
          type: "500px",
          link: "https://drscdn.500px.org/photo/232266589/m%3D900/v2?webp=true&sig=76f86cf5a589315b2143fb4f01d75e10454079efc2fff023bd2f21d88aa492c7"
        }]
      },

      // VIDEO
      // VIDEO
      // VIDEO

      {
        name: "Coubs",
        category: "video",
        coverTitle: "Coubs",
        coverPic: "p_coubs.jpg",
        roles: ["Camera", "Editing"],
        media: [{
          type: "coub",
          link: "//coub.com/embed/1006a2?muted=false&autostart=false&originalSize=false&startWithHD=true"
        }, {
          type: "coub",
          link: "//coub.com/embed/106hzg?muted=false&autostart=false&originalSize=false&startWithHD=true"
        }, {
          type: "coub",
          link: "//coub.com/embed/107xfa?muted=false&autostart=false&originalSize=false&startWithHD=true"
        }]
      }, {
        name: "Tel-Aviv",
        category: "video",
        coverTitle: "Tel-Aviv",
        coverPic: "p_tlv.jpg",
        roles: ["Camera", "VFX"],
        media: [{
          comment: "Short sketches from Tel-Aviv for Facebook & Instagram"
        }, {
          type: "fbVideo",
          link: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Filya.vasilyev.5817%2Fvideos%2F1827509104187814%2F&show_text=0&width=560"
        }, {
          type: "fbVideo",
          link: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Filya.vasilyev.5817%2Fvideos%2F1827510357521022%2F&show_text=0&width=560"
        }, {
          type: "fbVideo",
          link: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Filya.vasilyev.5817%2Fvideos%2F1827511114187613%2F&show_text=0&width=560"
        }, {
          type: "fbVideo",
          link: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Filya.vasilyev.5817%2Fvideos%2F1827512967520761%2F&show_text=0&width=560"
        }]
      }, {
        name: "Cartoons",
        category: "video",
        coverTitle: "Cartoons",
        coverPic: "p_cartoons.jpg",
        roles: ["Screenplay", "Hiring", "Motion design", "Editing", "VFX"],
        media: [{
          comment: "Totally five 3-minute cartoons, one 50-minute animated LED-background were made for children live shows at «Golden Ring» theatre"
        }, {
          type: "fbVideo",
          link: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FFluffymove%2Fvideos%2F678951658912009%2F&show_text=0&width=560",
          comment: "Director & Animator: Jane Nitylkina"
        }]
      }, {
        name: "Interactive comics",
        category: "video",
        coverTitle: "Interactive comics",
        coverPic: "p_fluffy_trailer.jpg",
        roles: ["Director", "Motion design", "VFX", "Sound design", "Music"],
        media: [{
          comment: "Video prototype of interactive comics made in Fluffy Move experimental studio"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/9r8w89_q8js?rel=0&amp;showinfo=0"
        }, {
          links: [{ text: "Fluffy Move", url: "https://fluffymove.com/" }, { text: "Fluffy Move FB", url: "https://www.facebook.com/Fluffymove/" }]
        }]
      }, {
        name: "Mini football promo",
        category: "video",
        coverTitle: "Mini football promo",
        coverPic: "p_minifootball.jpg",
        roles: ["Director", "Camera", "Motion design", "Sound design", "Editing"],
        media: [{
          comment: "Video promo for mini footbal championship"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/sW_qMY44Rn0?rel=0&amp;showinfo=0",
          links: [{ text: "Championship page", url: "https://vk.com/club81387426" }]
        }]
      }, {
        name: "«Week-clicks»",
        category: "video",
        coverTitle: "«Week-clicks»",
        coverPic: "p_weekclick.jpg",
        roles: ["Music", "Audio mixing", "Camera", "Editing", "VFX"],
        media: [{
          comment: "Series of short music videos"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/cw7rpIWv0lw?rel=0&amp;showinfo=0"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/K734wiM386c?rel=0&amp;showinfo=0"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/1W3LHcCG79A?rel=0&amp;showinfo=0"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/kcfJXzZY2T4?rel=0&amp;showinfo=0"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/bEmUfotmcGo?rel=0&amp;showinfo=0"
        }]
      }, {
        name: "Zooms",
        category: "video",
        coverTitle: "Zooms",
        coverPic: "p_zooms.jpg",
        roles: ["Motion design"],
        media: [{
          type: "fbVideo",
          link: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FFluffymove%2Fvideos%2F773981466075694%2F&show_text=0&width=560"
        }, {
          type: "youtube",
          link: "https://www.youtube.com/embed/4CKd5VbJU-M?rel=0&amp;showinfo=0"
        }]
      },

      // AUDIO
      // AUDIO
      // AUDIO

      {
        name: '«City birds»',
        category: "audio",
        coverTitle: '«City birds»',
        coverPic: "p_city_birds.jpg",
        roles: ["Music"],
        media: [{
          type: "youtube",
          link: "https://www.youtube.com/embed/B5T9bICijUs?rel=0&amp;showinfo=0",
          comment: "Feature film. Director: Yuliya Belaya",
          links: [{ text: "Full film", url: "https://www.youtube.com/watch?v=5vJFlzMYKRQ" }]
        }]
      }, {
        name: '«..., but love»',
        category: "audio",
        coverTitle: '«..., but love»',
        coverPic: "p_but_love.jpg",
        roles: ["Sound design", "Recording", "Audio mixing", "Music"],
        media: [{
          type: "pic",
          file: "p_but_love.jpg",
          comment: "Short film. Director: Yuliya Belaya. Film is not publicly available"
        }]
      }, {
        name: '«Russian Yogis»',
        category: "audio",
        coverTitle: '«Russian Yogis»',
        coverPic: "p_yogi.jpg",
        roles: ["Sound design", "Audio mixing", "Music", "Title design", "Poster desing"],
        media: [{
          type: "youtube",
          link: "https://www.youtube.com/embed/L8ojQ32UU3E?rel=0&amp;showinfo=0",
          comment: "Documentary film. Director: Leo Nekrasov"
        }]
      }, {
        name: '«Repka»',
        category: "audio",
        coverTitle: '"Repka"',
        coverPic: "p_repka.jpg",
        roles: ["Sound design", "Recording", "Audio mixing", "SFX"],
        media: [{
          type: "youtube",
          link: "https://www.youtube.com/embed/LuZ9xPAC82M?rel=0&amp;showinfo=0",
          comment: "Short film. Director: Leo Nekrasov"
        }]
      }, {
        category: "audio",
        coverTitle: "«Fake View»",
        coverDetails: "rock-band",
        coverPic: "p_fakeview.jpg",
        name: "«Fake View»",
        roles: ["Songwriting", "Composing", "Guitar", "Keys", "Vocals", "Sound engineering", "Design"],
        media: [{
          comment: "My own alternative-indie-rock band. Rocked for 3 years."
        }, {
          type: "pic",
          file: "p_fakeview1.jpg"
        }, {
          type: "soundcloud",
          link: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2026643&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true"
        }]
      }]
    };
  },

  created: function created() {
    this.sctollToTop();
  },
  methods: {
    sctollToTop: function sctollToTop() {
      window.scrollTo(0, 0);
    },
    expand: function expand(e, item) {
      if (!item.media) {
        return;
      } // do not expand empty items
      this.fullItem = item; // set clicked item as full item
      var offsetX = e.x - window.innerWidth / 2; // get click coordinates to expand from it
      var offsetY = e.y - window.innerHeight / 2; // get click coordinates to expand from it
      var full = document.querySelector('.full');
      var content = document.querySelector('.full .content');
      var dark = document.querySelector('.full .dark');
      // make all visible
      full.style.display = 'block';
      // hide overflow
      document.body.style.overflow = 'hidden';
      // instantly move content to click position
      content.style.transition = '0s';
      content.style.opacity = '0';
      content.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px) scale(.5)';
      // instantly make darkness invisible
      dark.style.transition = '0s';
      dark.style.opacity = '0';
      // then expand from click position
      this.$nextTick(function () {
        // animate content
        content.style.transition = '.3s';
        content.style.opacity = '1';
        content.style.transform = 'translate(0px,0px) scale(1)';
        // animate darkness
        dark.style.transition = '.5s';
        dark.style.opacity = '1';
      });
    },
    collapse: function collapse(e) {
      var full = document.querySelector('.full');
      var content = document.querySelector('.full .content');
      var dark = document.querySelector('.full .dark');
      var self = this;
      // animate content
      content.style.transition = '.3s';
      content.style.opacity = '0';
      content.style.transform = 'scale(.5)';
      // animate darkness
      dark.style.transition = '.5s';
      dark.style.opacity = '0';
      // show overflow
      document.body.style.overflow = 'auto';
      // hide and clean full when all animation is played
      setTimeout(function () {
        full.style.display = 'none';
        self.fullItem = {};
      }, 300);
    }
  }
});

/***/ }),

/***/ "B8sE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Config_vue__ = __webpack_require__("G0qw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b717e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Config_vue__ = __webpack_require__("va9f");
function injectStyle (ssrContext) {
  __webpack_require__("RjT1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62b717e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b717e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BXdI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EHzN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Contact")]),_c('p',[_vm._v("You can find me on:")]),_vm._m(0),_c('p',[_vm._v("But the best way to contact me is via e-mail, just drop your e-mail and messege here to start conversation")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"email","type":"text","placeholder":"e-mail"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},_vm.writing],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if(!$event.ctrlKey){ return null; }return _vm.sendButton($event)}}}),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],attrs:{"id":"msg","placeholder":"messege"},domProps:{"value":(_vm.msg)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value},_vm.writing],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if(!$event.ctrlKey){ return null; }return _vm.sendButton($event)}}}),(_vm.statusText)?_c('i',{class:_vm.status},[_vm._v(_vm._s(_vm.statusText))]):_vm._e(),(_vm.status !== 'success')?_c('button',{attrs:{"id":"sendButton","disabled":_vm.status == 'fail' || _vm.status == 'sending'},on:{"click":_vm.sendButton,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendButton($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if(!$event.ctrlKey){ return null; }return _vm.sendButton($event)}]}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_c('hr')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"likeButton",attrs:{"href":"https://www.facebook.com/ilya.vasilyev.5817","target":"_blank"}},[_vm._v("Facebook")]),_c('a',{staticClass:"likeButton",attrs:{"href":"https://github.com/ilya-vasilyev","target":"_blank"}},[_vm._v("GitHub")]),_c('a',{staticClass:"likeButton",attrs:{"href":"https://www.linkedin.com/in/ilya-vasilyev-71a12675/","target":"_blank"}},[_vm._v("LinkedIn")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec31da7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("EHzN");
function injectStyle (ssrContext) {
  __webpack_require__("09L2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ec31da7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec31da7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G0qw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'config',
  data: function data() {
    return {
      dataTable: [{ field: "full name", value: "Ilya Vasilyev" }, { field: "age", value: this.currentAge() }, { field: "from", value: "Moscow, Russia" }, { field: "languages", value: "English, Russian" }, { field: "frameworks", value: "Vue, Electron" }, { field: "animation", value: "GSAP, SVG, D3" }, { field: "pre-processors", value: "Pug, Sass" }, { field: "backend", value: "Node, Feathers, Firebase" }, { field: "module bundler", value: "webpack" }, { field: "git client", value: "GitKraken" }, { field: "repository hosting", value: "BitBucket" }, { field: "editor", value: "Atom" }, { field: "os", value: "Linux Mint" }]
    };
  },

  created: function created() {
    window.scrollTo(0, 0);
  },
  methods: {
    currentAge: function currentAge() {
      var currentTime = new Date();
      return currentTime.getMonth() + 1 < 9 ? currentTime.getFullYear() - 1991 - 1 : currentTime.getFullYear() - 1991; // correct year before and after september
    }
  }
});

/***/ }),

/***/ "IJsL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3c0b70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("9zQv");
function injectStyle (ssrContext) {
  __webpack_require__("BXdI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3c0b70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MTY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GoBack'
});

/***/ }),

/***/ "Mo2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_tooltip__ = __webpack_require__("VN6J");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_tooltip__["a" /* default */]);
// Vue.directive('tooltip', VTooltip)

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "O36n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skills_vue__ = __webpack_require__("2DCm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_265042f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Skills_vue__ = __webpack_require__("08Uv");
function injectStyle (ssrContext) {
  __webpack_require__("IJsL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-265042f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skills_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_265042f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Skills_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q6FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Nav',
  methods: {
    open: function open(path) {
      this.$router.push(path);
    }
  }
});

/***/ }),

/***/ "RjT1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58119d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("fc17");
function injectStyle (ssrContext) {
  __webpack_require__("seTk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58119d46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58119d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TXO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("It's Ilya")]),_c('p',[_vm._v("I'm a "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[0]),expression:"tooltips[0]"}]},[_vm._v("frontend developer")]),_vm._v(". Kind of. Because I was learning "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[1]),expression:"tooltips[1]"}]},[_vm._v("UI")]),_vm._v(" and "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[2]),expression:"tooltips[2]"}]},[_vm._v("UX")]),_vm._v(" while working as a "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[3]),expression:"tooltips[3]"}]},[_vm._v("designer")]),_vm._v(", when I realized that I need "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[4]),expression:"tooltips[4]"}]},[_vm._v("HTML and CSS")]),_vm._v(". Then "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[5]),expression:"tooltips[5]"}]},[_vm._v("JavaScript")]),_vm._v(" happened to me. With all forms of animations and interactivity.")]),_c('p',[_vm._v("All this resulted in my own startup. We produced "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[6]),expression:"tooltips[6]"}]},[_vm._v("Dynamic visualisation")]),_vm._v(" of "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[7]),expression:"tooltips[7]"}]},[_vm._v("Financial models")]),_vm._v(", that was a surprising twist to math, statistics and fin modeling.")]),_c('p',[_vm._v("At the same time I was involved in several non-coding projects like:"),_c('br'),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[8]),expression:"tooltips[8]"}]},[_vm._v("Sound production")]),_vm._v(", "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[9]),expression:"tooltips[9]"}]},[_vm._v("Audio recording and mixing")]),_vm._v(", "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[11]),expression:"tooltips[11]"}]},[_vm._v("Video production")]),_vm._v(" and "),_c('b',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltips[12]),expression:"tooltips[12]"}]},[_vm._v("Motion design")]),_vm._v(". All within film and animation industry.")]),_c('h3',{staticClass:"tldr"},[_vm._v("TL;DR: I'm the coder with broad cross discipline experience, focused on visualisation")]),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer'
});

/***/ }),

/***/ "WXDL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YPbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experience_vue__ = __webpack_require__("k8qa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c686edee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Experience_vue__ = __webpack_require__("ZTZ0");
function injectStyle (ssrContext) {
  __webpack_require__("Mo2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c686edee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experience_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c686edee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Experience_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Config__ = __webpack_require__("B8sE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Nav__ = __webpack_require__("uL8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Skills__ = __webpack_require__("O36n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Experience__ = __webpack_require__("YPbc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Portfolio__ = __webpack_require__("yRJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_GoBack__ = __webpack_require__("ysPb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer__ = __webpack_require__("TVmP");












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'All',
    components: {
      a: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */],
      b: __WEBPACK_IMPORTED_MODULE_3__components_Config__["a" /* default */],
      c: __WEBPACK_IMPORTED_MODULE_4__components_Nav__["a" /* default */],

      y: __WEBPACK_IMPORTED_MODULE_8__components_Contact__["a" /* default */],
      z: __WEBPACK_IMPORTED_MODULE_10__components_Footer__["a" /* default */]
    }
  }, {
    path: '/hello',
    name: 'Hello',
    components: {
      a: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */],
      z: __WEBPACK_IMPORTED_MODULE_9__components_GoBack__["a" /* default */]
    }
  }, {
    path: '/Config',
    name: 'Config',
    components: {
      a: __WEBPACK_IMPORTED_MODULE_3__components_Config__["a" /* default */],
      z: __WEBPACK_IMPORTED_MODULE_9__components_GoBack__["a" /* default */]
    }
  }, {
    path: '/skills',
    name: 'Skills',
    components: {
      a: __WEBPACK_IMPORTED_MODULE_5__components_Skills__["a" /* default */],
      z: __WEBPACK_IMPORTED_MODULE_9__components_GoBack__["a" /* default */]
    }
  }, {
    path: '/experience',
    name: 'Experience',
    components: {
      a: __WEBPACK_IMPORTED_MODULE_6__components_Experience__["a" /* default */],
      z: __WEBPACK_IMPORTED_MODULE_9__components_GoBack__["a" /* default */]
    }
  }, {
    path: '/portfolio',
    name: 'Portfolio',
    components: {
      a: __WEBPACK_IMPORTED_MODULE_7__components_Portfolio__["a" /* default */],
      z: __WEBPACK_IMPORTED_MODULE_9__components_GoBack__["a" /* default */]
    }
  }, {
    path: '/contact',
    name: 'Contact',
    components: {
      a: __WEBPACK_IMPORTED_MODULE_8__components_Contact__["a" /* default */],
      z: __WEBPACK_IMPORTED_MODULE_9__components_GoBack__["a" /* default */]
    }
  }]
}));

/***/ }),

/***/ "ZTZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Experience")]),_c('div',{staticClass:"container"},_vm._l((_vm.timeline),function(experience,index){return _c('div',{staticClass:"card",class:{expanded: _vm.expandedDetails == index},style:({cursor: experience.details ? 'pointer' : 'default'}),on:{"click":function($event){_vm.expandedDetails = experience.details ? index : -1}}},[_c('div',{staticClass:"pic",style:({ backgroundImage: 'url(../static/' + experience.pic + ')' })}),(experience.name)?_c('h3',[_vm._v(_vm._s(experience.name))]):_vm._e(),(experience.year)?_c('h4',[_vm._v(_vm._s(experience.year))]):_vm._e(),(experience.year)?_c('small',[_vm._v(_vm._s(experience.text))]):_vm._e(),(experience.details)?_c('div',{staticClass:"details"},[_c('button',{staticClass:"close",on:{"click":_vm.closeDetails}},[_vm._v("❌")]),_vm._l((experience.details),function(detail){return _c('div',{staticClass:"detail"},[(detail.text)?_c('p',[_vm._v(_vm._s(detail.text))]):_vm._e(),(detail.button && detail.href)?_c('a',{staticClass:"likeButton",attrs:{"href":detail.href,"target":"_blank"}},[_vm._v(_vm._s(detail.button))]):_vm._e()])})],2):_vm._e()])}),0),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e0SH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fc17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workarea"},[_c('footer',[_c('span',[_vm._v("Created with"),_c('a',{staticClass:"vue",attrs:{"href":"https://vuejs.org/","target":"_blank","title":"VueJS"}})]),_c('span',[_vm._v("in 2018")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hkmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Portfolio")]),_c('div',{staticClass:"filter"},_vm._l((_vm.categories),function(category,index){return _c('div',{class:{selected: index == _vm.currCategory}},[_c('span',[_vm._v("|")]),_c('p',{on:{"click":function($event){_vm.currCategory = index}}},[_vm._v(_vm._s(category.name))])])}),0),_c('div',{staticClass:"container"},_vm._l((_vm.items),function(item){return (item.category == _vm.categories[_vm.currCategory].name || _vm.currCategory == 0)?_c('div',{staticClass:"item",on:{"click":function($event){return _vm.expand($event, item)}}},[_c('div',{staticClass:"pic",style:({ backgroundImage: 'url(../static/' + item.coverPic + ')' })}),(item.coverTitle)?_c('h3',[_vm._v(_vm._s(item.coverTitle))]):_vm._e()]):_vm._e()}),0),_c('div',{staticClass:"full"},[_c('div',{staticClass:"dark",on:{"click":_vm.collapse}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"fullHead"},[(_vm.fullItem.name)?_c('h3',[_vm._v(_vm._s(_vm.fullItem.name))]):_vm._e(),_c('i',_vm._l((_vm.fullItem.roles),function(job){return (_vm.fullItem.roles)?_c('span',[_vm._v(_vm._s(job))]):_vm._e()}),0)]),_vm._l((_vm.fullItem.media),function(mediaItem,indexFull){return _c('div',{staticClass:"fullItem"},[(_vm.fullItem.name)?_c('hr'):_vm._e(),(mediaItem.commentBefore)?_c('p',{staticClass:"comment"},[_vm._v(_vm._s(mediaItem.commentBefore))]):_vm._e(),(mediaItem.type == 'pic')?_c('img',{staticClass:"pic",attrs:{"src":'../static/' + mediaItem.file}}):_vm._e(),(mediaItem.type == '500px')?_c('img',{staticClass:"pic",attrs:{"src":mediaItem.link}}):_vm._e(),(mediaItem.type == 'video')?_c('video',{staticClass:"video",attrs:{"poster":'../static/' + mediaItem.poster,"onclick":"this.play(); this.controls=true","controlsList":"nodownload"}},[_c('source',{attrs:{"src":'../static/' + mediaItem.file,"type":"video/mp4"}})]):_vm._e(),(mediaItem.type == 'youtube')?_c('iframe',{staticClass:"youtube",attrs:{"frameborder":"0","allowfullscreen":"allowfullscreen","src":mediaItem.link}}):_vm._e(),(mediaItem.type == 'coub')?_c('iframe',{staticClass:"coub",attrs:{"frameborder":"0","allowfullscreen":"allowfullscreen","src":mediaItem.link,"width":"640"}}):_vm._e(),(mediaItem.type == 'fbVideo')?_c('iframe',{staticClass:"fbVideo",attrs:{"frameborder":"0","allowfullscreen":"allowfullscreen","src":mediaItem.link,"width":"560"}}):_vm._e(),(mediaItem.type == 'soundcloud')?_c('iframe',{staticClass:"soundcloud",attrs:{"frameborder":"no","scrolling":"no","src":mediaItem.link,"width":"100%"}}):_vm._e(),(mediaItem.comment)?_c('p',{staticClass:"comment"},[_vm._v(_vm._s(mediaItem.comment))]):_vm._e(),(mediaItem.commentAfter)?_c('p',{staticClass:"comment"},[_vm._v(_vm._s(mediaItem.commentAfter))]):_vm._e(),_c('div',{staticClass:"links"},_vm._l((mediaItem.links),function(link){return (mediaItem.links)?_c('a',{staticClass:"likeButton",attrs:{"href":link.url,"target":"_blank"}},[_vm._v(_vm._s(link.text))]):_vm._e()}),0)])}),_c('button',{staticClass:"close",on:{"click":_vm.collapse}},[_vm._v("❌")])],2)]),_c('div',{staticClass:"filter"},_vm._l((_vm.categories),function(category,index){return _c('div',{class:{selected: index == _vm.currCategory}},[_c('span',[_vm._v("|")]),_c('p',{on:{"click":function($event){_vm.currCategory = index; _vm.sctollToTop()}}},[_vm._v(_vm._s(category.name))])])}),0),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k8qa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Experience',
  data: function data() {
    return {
      timeline: [
      // {
      // name: "...",
      // year: 2017,
      // text: "...",
      // pic: '',
      // details: [
      //   {text: "...", button: "Link", href:"./"},
      // ],
      // },
      {
        name: "Freelance coding",
        year: 2017,
        text: "Some small projects made as a frontend developer",
        pic: 'exp_code.jpg'
        // details: [
        //   {text: ""},
        // ],
      }, {
        name: "MeYou",
        year: 2017,
        text: "Second cooperation with event networking startup. This time in a more frontend way",
        pic: 'exp_meyou_again.jpg',
        details: [{ text: "Interactive product demos, internal tools, interface refactoring, new products" }]
      }, {
        name: "PULSE.visuals",
        year: 2017,
        text: "Dynamic visualisations of finatial models (reformation and rebranding of PLAIN.solutions)",
        pic: 'exp_pulse.jpg',
        details: [{ text: "New approach to value proposition and customer segments" }]
      }, {
        name: "Winning of the Garage48 hackathon",
        year: 2015,
        text: "This was the my first and the only hackathon. I joined a wonderful team of architects and we won it",
        pic: 'exp_garage.jpg',
        details: [{ text: "Prototype bootstrapping" }, { text: "Designing the interface" }, { text: "HTML, CSS, JS" }]
      }, {
        name: "PLAIN.solutions",
        year: 2014,
        text: "Dynamic visualisations of finatial models. The startup was founded by me and two executives from banking and oil industry. Real coding started here",
        pic: 'exp_plain.jpg',
        details: [{ text: "Several big cliens like PwC, Analytical Center, OTLK, Moscow State University" }]
      }, {
        name: "MeYou",
        year: 2014,
        text: "First cooperation with service for networking on events. It was my first steps into web design, HTML and CSS",
        pic: 'exp_meyou.jpg',
        details: [{ text: "Design and prototypes of all new interfaces" }, { text: "Help with organizing a series of tech meetups" }, { text: "A lot of networking" }]
      }, {
        name: "Animation",
        year: 2014,
        text: "I was involved in production of cartoons fully packed with traditional animation and motion design for children live shows",
        pic: 'exp_cartoons.jpg',
        details: [{ text: "3 short cartoons in 2014" }, { text: "2 short cartoons in 2016" }, { text: "1 animated LED-background in 2017" }]
      }, {
        name: "Fluffy Move Studio",
        year: 2013,
        text: "Experimental project about interactive comics, cartoons and web animation",
        pic: 'exp_fluffy.jpg',
        details: [{ text: "Product prototypes and trailers" }, { text: "Web experiments" }, { text: "Content marketing" }]
      }, {
        name: "Films",
        year: 2012,
        text: "My relation with cinematography is happened to be mainly in the sound and music area",
        pic: 'exp_films.JPG',
        details: [{ text: "Mixed puppet/stop-motion short film" }, { text: "Full length feature film" }, { text: "Documentary film" }]
      }, {
        name: "Music",
        year: 2009,
        text: "I've played in my own alternative-indie-rock band",
        pic: 'exp_fake.jpg',
        details: [{ text: "We've done plenty of live performances and made some studio recordings" }, { text: "Also I had a lot of sound engineering practice with other bands, both in studio and on stage" }, { text: "Real underground" }]
      }],
      expandedDetails: -1
    };
  },

  created: function created() {
    window.scrollTo(0, 0);
  },
  methods: {
    closeDetails: function closeDetails() {
      var self = this;
      this.$nextTick(function () {
        self.expandedDetails = -1;
      });
    }
  }
});

/***/ }),

/***/ "ktOg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nhD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workarea"},[_c('button',{staticClass:"white",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('span',{staticClass:"arrow"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 306 306"}},[_c('path',{attrs:{"d":"M247.3 35.7L211.7 0l-153 153 153 153 35.6-35.7L130 153"}})])]),_vm._v("Back to home page")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      tooltips: ["although, familiar with basics of backend", "how it looks", "how it feels", "like drawing apps in Photoshop, then explaining how it suppose to work", "to control how my design looks", "to control how my design works", "you manipulate input parameters of fin model to see simulated results of possible outomes in real time", "now I know how leveraged buyout works and what is terminal value", "like music composing, songwriting, instrumental arrangement", "drums, bass, guitars, vocals, both live and in studio", "", "from camera to rendering", "including animation, visual effects and post-production", ""]
    };
  },

  created: function created() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9207c4e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("TXO/");
function injectStyle (ssrContext) {
  __webpack_require__("WXDL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9207c4e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9207c4e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sJVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workarea"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.open('/skills')}}},[_c('svg',{staticClass:"pic",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('rect',{staticClass:"svg-rect-1-1",attrs:{"x":"2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-2",attrs:{"x":"2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-3",attrs:{"x":"2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-4",attrs:{"x":"2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-5",attrs:{"x":"2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-6",attrs:{"x":"21.6","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-7",attrs:{"x":"21.6","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-8",attrs:{"x":"21.6","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-9",attrs:{"x":"21.6","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-10",attrs:{"x":"21.6","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-11",attrs:{"x":"41.2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-12",attrs:{"x":"41.2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-13",attrs:{"x":"41.2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-14",attrs:{"x":"41.2","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-15",attrs:{"x":"41.2","y":"60","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-16",attrs:{"x":"60.8","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-17",attrs:{"x":"60.8","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-18",attrs:{"x":"60.8","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-19",attrs:{"x":"60.8","y":"60","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-20",attrs:{"x":"60.8","y":"50","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-21",attrs:{"x":"80.4","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-22",attrs:{"x":"80.4","y":"70","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-23",attrs:{"x":"80.4","y":"60","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-24",attrs:{"x":"80.4","y":"50","width":"17.6","height":"5"}}),_c('rect',{staticClass:"svg-rect-1-25",attrs:{"x":"80.4","y":"40","width":"17.6","height":"5"}})]),_c('p',{staticClass:"name"},[_vm._v("Skills")])]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.open('/experience')}}},[_c('svg',{staticClass:"pic",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('rect',{staticClass:"svg-rect-2-1",attrs:{"x":"20","y":"60","width":"60","height":"10"}}),_c('rect',{staticClass:"svg-rect-2-2",attrs:{"x":"20","y":"40","width":"60","height":"10"}}),_c('rect',{staticClass:"svg-rect-2-3",attrs:{"x":"20","y":"20","width":"60","height":"10"}}),_c('rect',{staticClass:"svg-rect-2-4",attrs:{"x":"20","y":"-30","width":"60","height":"10"}}),_c('rect',{staticClass:"svg-rect-2-5",attrs:{"x":"20","y":"-60","width":"60","height":"10"}})]),_c('p',{staticClass:"name"},[_vm._v("Experience")])]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.open('/portfolio')}}},[_c('svg',{staticClass:"pic",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('rect',{staticClass:"svg-rect-3-1",attrs:{"x":"20","y":"15","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-2",attrs:{"x":"43","y":"15","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-3",attrs:{"x":"67","y":"15","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-4",attrs:{"x":"20","y":"38","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-5",attrs:{"x":"43","y":"38","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-6",attrs:{"x":"20","y":"62","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-7",attrs:{"x":"110","y":"40","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-8",attrs:{"x":"110","y":"110","width":"15","height":"15"}}),_c('rect',{staticClass:"svg-rect-3-9",attrs:{"x":"40","y":"110","width":"15","height":"15"}})]),_c('p',{staticClass:"name"},[_vm._v("Portfolio")])])]),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "seTk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uL8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__("Q6FB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9220db2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__("sJVr");
function injectStyle (ssrContext) {
  __webpack_require__("ktOg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9220db2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9220db2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "va9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Config")]),_c('div',{staticClass:"ava"}),_c('div',{staticClass:"table"},_vm._l((_vm.dataTable),function(row){return _c('div',{staticClass:"row"},[_c('small',[_vm._v(_vm._s(row.field))]),_c('p',[_vm._v(_vm._s(row.value))])])}),0),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_typed_js__ = __webpack_require__("njrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_typed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_typed_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      menu: [{ name: 'home', path: '/' }, { name: 'skills', path: '/skills' }, { name: 'experience', path: '/experience' }, { name: 'portfolio', path: '/portfolio' }, { name: 'contact', path: '/contact' }],
      titles: ['hello', 'welcome', 'yo', 'sup', 'wazzup', 'hey ya', 'howdy', 'haaaiii', 'oi']
    };
  },

  created: function created() {
    window.scrollTo(0, 0);
  },
  mounted: function mounted() {
    this.rndTitle();
  },
  methods: {
    rndTitle: function rndTitle() {
      var titles = this.titles;
      var currentTitle = document.querySelector('#typed').textContent;

      function rnd() {
        var n = Math.floor(Math.random() * titles.length);
        return titles[n] == currentTitle ? rnd() : n; // recursive, to avoid the same title
      }

      var nnew = titles[rnd()];
      var typed = new __WEBPACK_IMPORTED_MODULE_0_typed_js___default.a('#typed', {
        strings: [currentTitle, nnew],
        startDelay: 0,
        backDelay: 150,
        typeSpeed: 40,
        backSpeed: 40,
        showCursor: false
      });
    }
  }
});

/***/ }),

/***/ "yRJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__ = __webpack_require__("B3Kk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af91b35c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__ = __webpack_require__("hkmj");
function injectStyle (ssrContext) {
  __webpack_require__("e0SH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af91b35c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af91b35c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ysPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoBack_vue__ = __webpack_require__("MTY4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e86729f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GoBack_vue__ = __webpack_require__("nhD7");
function injectStyle (ssrContext) {
  __webpack_require__("6X/W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e86729f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoBack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e86729f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GoBack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3cb736316873af79ae7e.js